export default class WindowEvents {

	static init() {
		let $window = jQuery( window );
		WindowEvents.lastScrollX = $window.scrollLeft();
		WindowEvents.lastScrollY = $window.scrollTop();
		WindowEvents.scheduledCalculateScroll = false;
		WindowEvents.scheduledCalculateResize = false;
		$window.on( 'scroll', WindowEvents.onScroll );
		$window.on( 'resize', WindowEvents.onResize );
	}

	static onScroll() {
		if ( WindowEvents.scheduledCalculateScroll ) {
			return;
		}
		WindowEvents.scheduledCalculateScroll = requestAnimationFrame( WindowEvents.triggerScrolled );
	}

	static onResize() {
		if ( WindowEvents.scheduledCalculateResize ) {
			return;
		}
		WindowEvents.scheduledCalculateResize = requestAnimationFrame( WindowEvents.triggerResized );
	}

	static triggerScrolled() {
		WindowEvents.scheduledCalculateScroll = false;
		let $window = jQuery( window );
		let scrollTop = $window.scrollTop();
		let scrolled = false;

		WindowEvents.bodyClasses();

		if ( scrollTop > WindowEvents.lastScrollY ) {
			scrolled = true;
			$window.trigger( "theme:scroll-down" );
			$window.triggerHandler( "hs:scroll-down" );
		} else if ( scrollTop < WindowEvents.lastScrollY ) {
			scrolled = true;
			$window.trigger( "theme:scroll-up" );
			$window.triggerHandler( "hs:scroll-up" );
		} else if ( $window.scrollLeft !== WindowEvents.lastScrollX ) {
			scrolled = true;
		}

		if ( scrolled ) {
			$window.trigger( "theme:scroll" );
			$window.triggerHandler( "hs:scroll" );
			WindowEvents.lastScrollX = $window.scrollLeft();
			WindowEvents.lastScrollY = $window.scrollTop();
		}
	}

	static bodyClasses() {
		let $window = jQuery( window );
		let $body = jQuery( document.body );
		let scrClass = 'scrolled-down';
		let scrFClass = 'scrolled-further-down';
		let scr1PClass = 'scrolled-one-page-down';
		let windowHeight = $window.height();
		let scrollTop = $window.scrollTop();

		if ( windowHeight < scrollTop ) {
			$body.addClass(scrClass + " " + scrFClass + " " + scr1PClass);
		} else if ( ( windowHeight * 0.66 ) < scrollTop ) {
			$body.addClass( scrClass + " " + scrFClass ).removeClass( scr1PClass );
		} else if ( 0 < scrollTop ) {
			$body.addClass( scrClass ).removeClass( scrFClass + " " + scr1PClass );
		} else {
			$body.removeClass( scrClass + " " + scrFClass + " " + scr1PClass );
		}

		if ( scrollTop > WindowEvents.lastScrollY ) {
			$body.addClass( "scroll-direction-down" ).removeClass( "scroll-direction-up" );
		} else if ( scrollTop < WindowEvents.lastScrollY ) {
			$body.addClass( "scroll-direction-up" ).removeClass( "scroll-direction-down" );
		}
	}

	static triggerResized() {
		WindowEvents.scheduledCalculateResize = false;
		jQuery(window).trigger( "theme:resize" );
		jQuery(window).triggerHandler( "hs:resize" );
		WindowEvents.onScroll();
	}
}
